import Settings from 'src/Settings';
import RedesignDescriptor from './onboarding-module-redesign';
import CanteenDescriptor from './onboarding-module-canteen';
import AramarkDescriptor from './onboarding-module-aramark';
import CompanyKitchenDescriptor from './onboarding-module-companykitchen';
import RefiveDescriptor from './onboarding-module-refive';
import {BuildTypeEnum} from '../../../../constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
};

export function getOnboardingDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
